import { useGtm as useGtmInstance, type TrackEventOptions } from '@gtm-support/vue-gtm';

export function useGtm() {
	const gtm = useGtmInstance();

	const trackEvent = (eventData?: TrackEventOptions) => {
		if (gtm) {
			// Load UTM parameters from session storage at the time of the event
			const storedUtmValues = getSessionStorage(SESSION_STORAGE_ITEMS.UTM);
			const utmParams = storedUtmValues && typeof storedUtmValues === 'object' ? storedUtmValues : {};

			gtm.trackEvent({
				...eventData,
				// Spread UTM parameters as event parameters for GA4
				...utmParams,
			});
		} else {
			console.warn('GTM is not initialized');
		}
	};

	return {
		trackEvent,
	};
}